import { select } from 'redux-saga/effects';
import { ReaderTaskState } from '@restore/readerTask/readerTask.types';
import { selectReaderTaskState } from '@restore/readerTask/readerTask.slice';
import { selectClinicalTrialInventoryState } from '@restore/clinicalTrialInventory/clinicalTrialInventory.slice';
import { selectConfig } from '@restore/clinicalTrialContext/clinicalTrialContext.slice';
import { ClinicalTrialInventoryState } from '@restore/clinicalTrialInventory/clinicalTrialInventory.types';

export function* prepareCommonData() {
  const taskState: ReaderTaskState = yield select(selectReaderTaskState);
  const inventoryState: ClinicalTrialInventoryState = yield select(
    selectClinicalTrialInventoryState
  );
  const ctxConfig: ReturnType<typeof selectConfig> = yield select(selectConfig);

  const task = taskState.data;
  const currentVisit = task?.visits?.find(v => v.visitId === task?.visitId);

  const { measurements, instruments, scoringForms } = inventoryState;

  const formConfig = scoringForms.find(
    ({ code }) => code === currentVisit?.scoringCode
  );

  const labelGroups = ctxConfig?.labelGroups;
  const clinicalTrialName = ctxConfig?.name;

  return {
    task,
    currentVisit,
    measurements,
    instruments,
    scoringForms,
    formConfig,
    labelGroups,
    clinicalTrialName,
  };
}
